export enum RouteName {
  // /login
  AUTH = "auth",
  LOGIN = "login",
  USER_ONBOARD = "userOnboard",
  PASSWORD_RESET_REQUEST = "passwordResetRequest",
  PASSWORD_RESET = "passwordReset",
  MAGIC_LINK = "magicLink",
  MFA = "mfa",
  RECOVERY_CODE_LOGIN = "recoveryCodeLogin",
  // /
  DASHBOARD = "dashboard",
  // /organisations
  ORGANISATIONS = "organisations",
  ORGANISATION_LIST = "organisationsList",
  ORGANISATION_NEW = "organisationsNew",
  ORGANISATION_EDIT = "organisationsEdit",
  SYSTEM_CONTENT = "systemContent",
  SCENARIO_TREES = "scenarioTrees",
  SUITE_STATE = "suiteState",
  // / organisations/suiteState
  SUITE_STATE_LIST = "suiteStateList",
  SUITE_STATE_UPDATE = "suiteStateUpdate",
  // /serviceplan
  SERVICE_PLANS = "servicePlans",
  SERVICE_PLAN_EDIT = "servicePlanEdit",
  SERVICE_PLAN_CREATE = "servicePlanCreate",
  SERVICE_PLAN_LIST = "servicePlanList",
  SERVICE_PLAN_TRANSFER_GROUPS = "servicePlanTransferGroups",
  // /users/id
  USER = "user",
  USER_SUBMIT_SCORE = "user-submit-score",
  USER_EDIT = "user-edit",
  USER_MODULE_STATS = "user-module-stats",
  USER_SCORE_REPORTS = "user-score-reports",
  USER_SCORE_REPORT = "user-score-report",
  HEATMAP_VISUALISER = "heatmap-visualiser",
  // /users
  USERS = "users",
  ADD_USERS = "add-users",
  // /groups
  GROUPS = "groups",
  GROUP_LIST = "groupsList",
  GROUP_USERS = "groupUsers",
  GROUP_EDIT = "groupEdit",
  GROUP_CREATE = "groupCreate",
  GROUP_EDIT_MANAGERS = "groupEditManagers",
  GROUP_EDIT_LEARNERS = "groupEditLearners",
  GROUP_ASSIGN_SUITES = "groupAssignSuites",
  GROUPS_TRAINING_TIMES = "groups-training-times",
  SUITE_MANAGEMENT = "suite-management",
  // Non-nested routes:
  TRENDS_ANALYTICS = "trends-analytics",
  ANALYTICS = "analytics",
  ANALYTICS_OVERVIEW = "analytics-overview",
  ANALYTICS_LEADERBOARD = "analytics-leaderboard",
  LEARNING_MATERIALS = "learning-materials",
  REPORT_GENERATOR = "report-generator",
  MY_PROFILE = "my-profile",
  MY_LEARNING = "my-learning",
  ORGANISATION_LOGIN = "organisationLogin",
  NOT_FOUND = "notFound",
  AUDIT = "audit",
  LEADERBOARD = "leaderboard",
  MOONBOARDING = "moonboarding",
  WELCOME = "welcome",
  PLATFORM_ISSUES = "platform-issues",
  SYSTEM = "system",
  SYSTEM_NAV = "system-nav",
  APP_VERSION = "app-versions",
  DATA_OPERATIONS = "data-operations",
  DEV_ICONS = "dev-icons",
}

export type RouteNameWithMeta = RouteName;
